<template>
  <div class="sos-download-page">
    <div class="center"><h1>{{ $t('title') }}</h1></div>
    <div><img class="sos-download-logo" src="../assets/sos-logo.png" alt="sos-logo" /></div>

    <div class="sd-windows-mac-block" v-if="!iOS && !android">
    <h2>{{ $tc('subtitle', 0) }}</h2>
    <div class="product-content-block">
    <ol>
      <li>
        <div>{{ $t('desktop.points[0][0]') }}</div>
        <div>{{ $t('desktop.points[0][1]') }}</div>
        <DownloadLinks :os="os" />
      </li>
      <li v-html="$t('desktop.points[1]')"></li>
      <li>{{ $t('desktop.points[2]') }}</li>
    </ol>

    <p>{{ $t('desktop.descOne') }}</p>
    <p>{{ $t('desktop.descSecond') }}</p>
    </div>
    </div>

    <div class="sd-ios-block" v-if="iOS === true">
    <h2>{{ $tc('subtitle', 1) }}</h2>
    <div class="product-content-block">
    <ol>
      <i18n path="iOSDevice.points[0][0]" tag="li">
        <template #iosDownload>
          <a :href="iosDownload" target="_blank" rel="noopener">{{ $t('iOSDevice.points[0][1]')}}</a>
        </template>
      </i18n> 
      <li v-html="$t('iOSDevice.points[1]')"></li>
      <li>{{ $t('iOSDevice.points[2]') }}</li>
    </ol>

    <p>{{ $t('iOSDevice.descOne') }}</p>
   <!-- <i18n path="iOSDevice.descSecond[0]" tag="p">
      <template #here>
        <a :href="iosDownload" class='watch-video' data-fancybox target="_blank" rel="noopener">{{ $t('iOSDevice.descSecond[1]')}}</a>
      </template>
    </i18n>-->
    </div>
    </div>


    <div class="sd-android-block" v-if="android === true">
      <h2>{{ $tc('subtitle', 2, {'deviceType': deviceType}) }}</h2>
      <div class="product-content-block">
        <ol>
          <i18n path="androidDevice.points[0][0]" tag="li">
            <template #googlePlay>
              <a :href="androidLink" target="_blank" rel="noopener">{{ $t('androidDevice.points[0][1]')}}</a>
            </template>
            <template #APK>
              <a :href="androidAPK" target="_blank" rel="noopener">{{ $t('androidDevice.points[0][2]')}}</a>
            </template>
          </i18n> 
          <li v-html="$t('androidDevice.points[1]')"></li>
          <li>{{ $t('androidDevice.points[2]') }}</li>
        </ol>

        <p>{{ $t('androidDevice.descOne') }}</p>
        <!--<i18n path="androidDevice.descSecond[0]" tag="p">
          <template #here>
            <a class='watch-video' data-fancybox :href='androidVideo' target='_blank' rel='noopener'>{{ $t('androidDevice.descSecond[1]') }}</a>
          </template>
        </i18n>-->
      </div>
    </div>
  </div>
</template>

<script>
import DownloadLinks from '@/components/DownloadLinks.vue'
import consts from '../assets/consts.js'

export default {
  name: 'SOS',
  components: {
    DownloadLinks
  },
  data: function() {
    return {
      iOS: false,
      android: false,
      os: "windows",
      linkQuery: this.$route.query,
      OS: navigator.userAgent.toLowerCase(),
      iosDownload: consts.iosDownload,
      iosVideo: consts.iosVideo,
      androidLink: consts.androidDownload,
      androidAPK: consts.androidAPK,
      androidVideo: consts.androidVideo,
      androidDownloadCN: consts.androidDownloadCN,
      iosDownloadCN: consts.iosDownloadCN,
      deviceType: "Android"
    }
    
  },
  methods: {
    checkDevice() {
      if (this.OS.indexOf("iphone") != -1 || this.OS.indexOf("ipod") != -1 || this.OS.indexOf("ipad") != -1 || (this.OS.match(/mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2)) {
        this.os = "ios";
        this.iOS = true;
      } else if (this.OS.indexOf("android") != -1 || /\bCrOS\b/.test(navigator.userAgent) ) {
        this.os = "android";
        this.android = true;
        if (/\bCrOS\b/.test(navigator.userAgent)) {
          this.deviceType = "Chromebook"
        } else {
          this.deviceType = "Android"
        }
      } else if (this.OS.indexOf("mac") != -1) {
        this.os = "mac"
      } 
      //update CN links
      if (
        this.$route.params.lang === 'cn'
        && this.linkQuery.region !== 'eu'
        && location.host.indexOf('.eu') === -1
        && this.linkQuery.region !== 'oc'
        && location.host.indexOf('.nr') === -1
      ) {
        this.androidLink = this.androidDownloadCN
        this.iosDownload = this.iosDownloadCN
      }
    },
    testDevice() {
       // Get device override
      var params = this.linkQuery;
      if (getDeviceOverride() != '') {
        if (getDeviceOverride() === "ios" || getDeviceOverride() === "ipad") {
          this.iOS = true;
        } else if (getDeviceOverride() === "android" || getDeviceOverride() === "chrome") {
          this.android = true;
          if (getDeviceOverride() === "chrome") {
            this.deviceType = "Chromebook"
          } else {
            this.deviceType = "Android"
          }
        } else {
          this.iOS = false;
          this.android = false;
          if (getDeviceOverride() === "mac") {
            this.os = "mac"
          } else if (getDeviceOverride() === "windows") {
            this.os = "windows"
          }
        }
      }
      function getDeviceOverride() {
        // If there is a device param in the query string
        //var params = getQueryStrings();
        if('device' in params) {
          return params.device;
        }
        return '';
      }
    }
  },
  created() {
    this.checkDevice();
    this.testDevice();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
